type ShortcutKeyEvent = Pick<KeyboardEvent, "key" | "metaKey" | "ctrlKey">;

/** Cmd+Enter (macOS) or Ctrl+Enter: send from a multi-line text field, where plain Enter adds a line. */
export const isSubmitShortcut = (event: ShortcutKeyEvent): boolean =>
  event.key === "Enter" && (event.metaKey || event.ctrlKey);
